import { render, staticRenderFns } from "./TriangleSquare.vue?vue&type=template&id=70208350&"
import script from "./TriangleSquare.vue?vue&type=script&lang=js&"
export * from "./TriangleSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports